import PropTypes from 'prop-types';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import { reduxForm } from 'redux-form';
import Dialog from 'infrastructure/js/components/Dialog/dialog';
import InputSection from 'infrastructure/js/components/Dialog/InputSection/inputSection';
import TextAreaField from 'infrastructure/js/components/controls/TextAreaField/textAreaField';

import './cocAcceptanceRequestDialog.scss';


export function CocAcceptanceRequestDialog({
                                             actions,
                                             sData,
                                             handleSubmit,
                                             reloadParentComponent
}) {
  const dialogLabels = createLabelHelper('mat.dialog.');
  const labels = createLabelHelper('mat.forms.cocTestForm.dialog.cocAcceptanceRequest.');

  const onSubmit = (data) => {
    const dialogData = sData?.get('dialogData');

    let newData = {
      comment: data.comments,
      setId: dialogData.setId
    };

    actions.submit(newData, null, reloadParentComponent);
  };

  const onHide = () => {
    actions.hide();
  };

  const getDialogButtons = () => {
    return {
      left: [
        {
          id: 'cancel',
          text: dialogLabels.get('cancel'),
          action: actions.hide,
        },
      ],
      right: [
        {
          id: 'submit',
          text: dialogLabels.get('ok'),
          bsStyle: 'primary',
          loading: sData.get('loading'),
          action: handleSubmit(onSubmit),
          disabled: sData.get('loading'),
        },
      ],
    };
  };

  return (
    <Dialog
      id="coc-acceptance-request-dialog"
      className="coc-acceptance-request-dialog"
      titleText={labels.get('header.title')}
      show={true}
      onHide={onHide}
      sData={sData}
      footerButtons={getDialogButtons()}
    >

      <div>{labels.get('top.title', '', {setName: sData?.get('dialogData')?.setName})}</div>

      <InputSection htmlFor="comments" className=""
                    label={labels.get('comments')}>
        <TextAreaField id="comments" name="comments" rows={5}
                       placeholder={labels.get('comments.placeholder')}/>
      </InputSection>

    </Dialog>
  );
}

CocAcceptanceRequestDialog.propTypes = {
  actions: PropTypes.object.isRequired,
  sData: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  reloadParentComponent: PropTypes.func,
};

export default reduxForm({
  form: 'cocAcceptanceRequestDialog',
})(CocAcceptanceRequestDialog);
